import { render, staticRenderFns } from "./PrivacyAndSecurity.vue?vue&type=template&id=8f290b66&"
import script from "./PrivacyAndSecurity.vue?vue&type=script&lang=js&"
export * from "./PrivacyAndSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports